// extracted by mini-css-extract-plugin
export default {"loader":"src-signer-app-parts-full-page-loader-full-page-loader-module__loader--FGLF9"};